'use client';

import { I18nProvider } from '@lingui/react';
import { i18n as globalI18n, type Messages, setupI18n } from '@lingui/core';
import { useEffect, useState } from 'react';

type Props = {
  children: React.ReactNode;
  initialLocale: string;
  initialMessages: Messages;
};

export function LinguiClientProvider({ children, initialLocale, initialMessages }: Props) {
  const [i18n] = useState(() => {
    const instance = setupI18n({
      locale: initialLocale,
      messages: { [initialLocale]: initialMessages },
    });
    instance.activate(initialLocale);
    return instance;
  });

  useEffect(() => {
    globalI18n.loadAndActivate({
      locale: initialLocale,
      messages: initialMessages,
    });
  }, [initialLocale, initialMessages]);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
